import HeadTittle from "../../../components/HeadTittle";
import {permissionObj} from "../../../Helpers/permission";
import ButtonAction from "../../../components/buttons/ButtonAction";
import {AddIcon, TrashOutlineIconWhite} from "../../../components/buttons/IconButtons";
import {TransportRequestApp} from "./Funtionality/TransportRequestApp";
import routes from "../../../Routes/routes";
import ExportDataBtn from "../../../components/buttons/ExportDataBtn";
import React from "react";
import DeleteModal from "../../Modals/DeleteModal";
import TransportRequestSupplier from "./SubComponents/TransportRequestSupplier";
import RequestGenericCommentFieldModal from "./Modal/RequestGenericCommentFieldModal";
import RequestCommentModal from "./Modal/RequestCommentModal";
import RenderExpandedRow from "./SubComponents/RenderExpandedRow";
import TransportRequestTable from "./TransportRequestTable";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const TransportRequest = () => {
    const{
        setShowDeleteModal,
        showDeleteModal,
        commentModals,
        genericCommentModals,
        row,
        DEV,
        permission,
        deleteModal,
        searchElement,
        setSearchElement,
        setBodyForExport,
        option,
        setSearch,
        simpleSearch,
        setSimpleSearch,
        supplierId,
        selectedList,
        setSelectedList,
        setModified,
        modified,
        navigate,
        t,
        search,
        moduleId,
        criteria,
        setCriteria,
        bodyForExport,
        filterDialogShow,
        setFilterDialogShow,
        setFinalArray,
        finalArray,
        setShowAcceptRequest,
        setShowDeclineRequest,
        setShowAssignEmployeesAndVehicles,
        setShowPreDepartureComment,
        setShowDepartureComment,
        setShowArrivalComment,
        setShowDetails,
        setShowInTransitIssueComment,
        setShowIssueComment,
        setRow,
        steps,
        activeStep,
        setActiveStep,
        handleStepChange,
        setIsAllChecked
    } = TransportRequestApp()

    if(!DEV && !permission?.includes(permissionObj.WEB_LOGISTIC_REQUEST_READ) && supplierId === null)
        navigate(routes.forbidden);

    return (
        <>
            <HeadTittle name={'transport_request'}>
                {(DEV || permission?.includes(permissionObj?.WEB_LOGISTIC_REQUEST_EXPORT)) &&
                    (search ? (
                        <ExportDataBtn
                            id='btn_tr_export_data'
                            moduleId={moduleId}
                            body={criteria}
                            search={search}
                            option={option}
                        />
                    ) : (
                        <ExportDataBtn
                            id='btn_tr_export_data'
                            moduleId={moduleId}
                            searchElement={searchElement}
                            search={search}
                            option={option}
                            body={bodyForExport}
                        />
                    ))}

                {
                    supplierId == null &&
                        <>
                            {(DEV || permission?.includes(permissionObj?.WEB_LOGISTIC_REQUEST_CREATE)) && (
                                <ButtonAction
                                    id='btn_tr_add'
                                    name='create'
                                    className='btn-icon-add'
                                    Icon={AddIcon}
                                    url={routes.transportRequest.create}
                                    splitName={false}
                                />)}
                            {(DEV || permission?.includes(permissionObj?.WEB_LOGISTIC_REQUEST_DELETE)) && (
                                <ButtonAction
                                    id='btn_tr_delete'
                                    name='delete'
                                    className='btn-icon-delete'
                                    disabled={selectedList?.length === 0}
                                    Icon={TrashOutlineIconWhite}
                                    onClick={() => {
                                        setShowDeleteModal(true);
                                    }}
                                />)}
                        </>
                }
            </HeadTittle>

            {supplierId === null ? (
                <TransportRequestTable
                    option={option}
                    modified={modified}
                    setModified={setModified}
                    setBodyForExport={setBodyForExport}
                    setCriteria={setCriteria}
                    selectedList={selectedList}
                    setSelectedList={setSelectedList}
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    setIsAllChecked={setIsAllChecked}
                    setSearch={setSearch}
                    simpleSearch={simpleSearch}
                    setSimpleSearch={setSimpleSearch}
                    setShowAcceptRequest={setShowAcceptRequest}
                    setRow={setRow}
                    setShowDeclineRequest={setShowDeclineRequest}
                    setShowAssignEmployeesAndVehicles={setShowAssignEmployeesAndVehicles}
                    setShowPreDepartureComment={setShowPreDepartureComment}
                    setShowInTransitIssueComment={setShowInTransitIssueComment}
                    setShowIssueComment={setShowIssueComment}
                    setShowDetails={setShowDetails}
                    setShowDepartureComment={setShowDepartureComment}
                    setShowArrivalComment={setShowArrivalComment}
                    setShowDeleteModal={setShowDeleteModal}
                />
            ) : (
                <TransportRequestSupplier
                    supplierId={supplierId}
                    setShowDeleteModal={setShowDeleteModal}
                    setShowAcceptRequest={setShowAcceptRequest}
                    setShowDeclineRequest={setShowDeclineRequest}
                    setShowAssignEmployeesAndVehicles={setShowAssignEmployeesAndVehicles}
                    setShowPreDepartureComment={setShowPreDepartureComment}
                    setShowDepartureComment={setShowDepartureComment}
                    setShowArrivalComment={setShowArrivalComment}
                    setShowDetails={setShowDetails}
                    setShowInTransitIssueComment={setShowInTransitIssueComment}
                    setShowIssueComment={setShowIssueComment}
                    setRow={setRow}
                    steps={steps}
                    activeStep={activeStep}
                    setActiveStep={setActiveStep}
                    handleStepChange={handleStepChange}
                    modified={modified}
                    setModified={setModified}
                />
            )}
            {genericCommentModals.map(({ show, setter, title, flagProp }, idx) => (
                show && <RequestGenericCommentFieldModal
                    key={idx}
                    show={show}
                    onHide={() => setter(false)}
                    title={title}
                    setModified={setModified}
                    modified={modified}
                    row={row}
                    supplierId={supplierId}
                    {...flagProp}
                />
            ))}
            {commentModals.map(({ show, setter, title, flagProp }, idx) => (
                show && <RequestCommentModal
                    key={idx}
                    show={show}
                    onHide={() => setter(false)}
                    title={title}
                    setModified={setModified}
                    modified={modified}
                    row={row}
                    renderExpandedRow={RenderExpandedRow}
                    supplierId={supplierId}
                    {...flagProp}
                />
            ))}

            <DeleteModal
                show={showDeleteModal}
                onHide={() => setShowDeleteModal(false)}
                onClickFn={() => deleteModal(selectedList)}
                data={selectedList}
                isReset={setSelectedList}
                isAllReset={setIsAllChecked}
                title_modal={t('delete_transport_request')}
                description={'are_you_sure_you_want_to_delete'}
                element_modal={t('transport_request')}
            />
        </>
    )
}

export default TransportRequest;
